
//e.g. sortArrayByStrings(resp.result, ["space.longName", "space.name"])
export const sortArrayByStrings = <T>(arr: T[], keys: string[]): T[] => {
  if (arr == null) {
    return [];
  }
  return [...arr].sort(function (a, b) {
    for (const key of keys) {
      const valA = getPath(a, key) as string;
      const valB = getPath(b, key) as string;

      const _a = valA == null ? "" : valA.toUpperCase();
      const _b = valB == null ? "" : valB.toUpperCase();

      if (_a < _b) {
        return -1;
      }
      if (_a > _b) {
        return 1;
      }
    }
    return 0;
  });
};

export const sortArrayByNumbers = <T>(
  arr: T[],
  keys: string[],
  order: "asc" | "desc" = "asc"
): T[] => {
  if (arr == null) return [];
  const toNum = (v: any): number | null => {
    if (v == null) return null;
    const n = typeof v === "number" ? v : parseFloat(v);
    return isNaN(n) ? null : n;
  };
  const dir = order === "asc" ? 1 : -1;
  return [...arr].sort((a, b) => {
    for (const key of keys) {
      const valA = toNum(getPath(a, key));
      const valB = toNum(getPath(b, key));

      const _a = valA == null ? Number.NEGATIVE_INFINITY : valA;
      const _b = valB == null ? Number.NEGATIVE_INFINITY : valB;

      if (_a < _b) return -1 * dir;
      if (_a > _b) return 1 * dir;
    }
    return 0;
  });
};

export const formatShortDate = (date: string | null | undefined | Date): string => {
  if (date == null) {
    return "";
  }
  return new Date(date).toLocaleDateString();
};

function getPath(obj: any, path: string): string | undefined {
  return path.split(".").reduce((acc, key) => {
    return acc?.[key];
  }, obj);
}
